import { render, staticRenderFns } from "./ErrorReportRoot.vue?vue&type=template&id=28138e66"
import script from "./ErrorReportRoot.vue?vue&type=script&lang=ts"
export * from "./ErrorReportRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports